<template>
    <jet-form-section @submitted="saveAchievementBadges">
        <template #title>
            Achievement Badges
        </template>
        <template #description>
            Please select any 3 achievements which you want to show on "Global Leaderboard".
        </template>
        <template #form>
            <div class="col-span-6 sm:col-span-4">
                <jet-label for="achievement_badges" class="mb-1" value="Select Achievements"/>
                <multiselect 
                    v-model="form.achievement_badges" 
                    @update:modelValue="handleInput"
                    selectLabel="" 
                    deselectLabel=""  
                    placeholder="Select Achievement" 
                    label="name" 
                    value="id" 
                    name="achievement_badges" 
                    track-by="id" 
                    :options="achievementOption" 
                    :multiple="true" 
                    :taggable="true"
                ></multiselect>
            </div>
        </template>
        <template #actions>
            <jet-action-message :on="form.recentlySuccessful" class="mr-3">
                Saved.
            </jet-action-message>
            <jet-button :class="{ 'opacity-25': form.processing }" :disabled="form.processing">
                Save
            </jet-button>
        </template>
    </jet-form-section>
</template>

<script>
import JetActionMessage from '@/Jetstream/ActionMessage.vue'
import JetButton from '@/Jetstream/Button.vue'
import JetFormSection from '@/Jetstream/FormSection.vue'
import JetInput from '@/Jetstream/Input.vue'
import JetInputError from '@/Jetstream/InputError.vue'
import JetLabel from '@/Jetstream/Label.vue'
import Multiselect from '@suadelabs/vue3-multiselect'

export default {
    components: {
        JetActionMessage,
        JetButton,
        JetFormSection,
        JetInput,
        JetInputError,
        JetLabel,
        Multiselect,
    },

    data() {
        return {
            achievementOption: [],
            form: this.$inertia.form({
                achievement_badges: []
            }),
        }
    },

    mounted() {
        this.loadAchievementOptions();
        this.setUserAchievementBadges();
    },

    methods: {
        loadAchievementOptions() {
            const achievementBadges = this.$page.props.achievementBadges;
            this.achievementOption = achievementBadges.map(badge => ({
                id: badge.achievement_badge.id,
                name: badge.achievement_badge.name,
            }));
        },

        setUserAchievementBadges() {
            const userAchievementIds = this.$page.props.user.achievement_ids ?? [];
            this.form.achievement_badges = this.achievementOption.filter(option =>
                JSON.parse(userAchievementIds).includes(option.id)
            );
        },

        handleInput(value) {
            if (value.length > 3) {
                value.pop();
            }
            this.form.achievement_badges = value;
        },

        saveAchievementBadges() {
            this.form.post(route('achievement.save'), {
                errorBag: 'saveAchievement',
                preserveScroll: true,
                onSuccess: () => {
                    
                },
                onError: () => {
                    
                }
            });
        },
    },
}
</script>

<style src="@suadelabs/vue3-multiselect/dist/vue3-multiselect.css"></style>
<style scoped>
.multiselect__input:focus{
    outline: 0;
}
:deep(.multiselect__option--highlight) {
    background: #FCEA0D !important;
    color: #000 !important;
}
</style>
